module.exports = __webpack_public_path__ + "static/benefits-1-d1617cdca11273ea0c666a5ef44d0797.png";